import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { AppHeader } from 'components';

import AccommodationsList from './components/accommodations-list/AccommodationsList';

import useStyles from './styles';

const BookAccommodationList = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.root}>
      <AppHeader />

      <div className={classes.toolbar}>
        <Typography variant="h2" className={classes.toolbarTitle}>
          {t('Book Accommodation')}
        </Typography>
      </div>

      <div className={classes.listWrapper}>
        <AccommodationsList />
      </div>
    </div>
  );
};

export default BookAccommodationList;
